import { render } from "./ViewWrapperView.vue?vue&type=template&id=60091e63"
import script from "./ViewWrapperView.vue?vue&type=script&lang=js"
export * from "./ViewWrapperView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__